export const TERM_MONTHS_AMORTIZATION_SCHEDULE = {
  36: { 1: 1, 2: 2, 3: 3 },
  48: { 1: 1, 2: 2, 3: 3, 4: 4 },
  60: { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 },
  72: { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6 },
  120: { 1: 1, 2: 2, 3: 3, 5: 5, 7: 7, 10: 10 },
  180: { 1: 1, 3: 3, 5: 5, 9: 9, 11: 11, 15: 15 },
  240: { 1: 1, 4: 4, 7: 7, 10: 10, 15: 15, 20: 20 },
  300: { 1: 1, 5: 5, 10: 10, 15: 15, 20: 20, 25: 25 },
  360: { 1: 1, 5: 5, 10: 10, 15: 15, 20: 20, 30: 30 },
};

export const borderAndBackgroundColor = {
  0: {
    borderColor: 'rgba(255, 99, 132, 1)',
    backgroundColor: 'rgba(255, 99, 132, .5)',
  },
  1: {
    borderColor: 'rgba(240, 130, 85, 1)',
    backgroundColor: 'rgba(240, 130, 85, .5)',
  },
  2: {
    borderColor: 'rgba(54, 162, 235, 1)',
    backgroundColor: 'rgba(54, 162, 235, .5)',
  },
};

export const LOAN_RATE_TERM_MONTH_CHECK = {
  Auto: (val = 0) => Number(val),
  Home: (val = 0) => Number(val) / 12,
};

export const FEDERAL_CREDIT_UNION = 'Federal Credit Union';
export const COMMUNITY_CREDIT_UNION = 'Community Credit Union';
export const EMPLOYEES_CREDIT_UNION = 'Employees Credit Union';
export const GOUVERNEUR_SAVINGS = 'Gouverneur Savings & Loan Association';

export const FCU = 'FCU';
export const CCU = 'CCU';
export const ECU = 'ECU';
export const GSL = 'GSL';

export const PRINCIPAL_PAID = 'Principal Paid';
export const INTEREST_PAID = 'Interest Paid';

export const FIVE = 5;
export const THREE = 3;
